(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5677],{

/***/ 5677:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ AboutParallelogram; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./src/components/AboutPage/AboutParallelogram/AboutParallelogram.module.scss
var AboutParallelogram_module = __webpack_require__(6903);
var AboutParallelogram_module_default = /*#__PURE__*/__webpack_require__.n(AboutParallelogram_module);
// EXTERNAL MODULE: ./public/logo.png
var logo = __webpack_require__(3476);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/future/image.js
var future_image = __webpack_require__(1608);
var image_default = /*#__PURE__*/__webpack_require__.n(future_image);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./src/components/HomePage/ParallelogramImage/ParallelogramImage.jsx





function ParallelogramImage(_ref) {
  var backgroundPath = _ref.backgroundPath,
      imageMeta = _ref.imageMeta;
  return /*#__PURE__*/_jsx(Container, {
    children: /*#__PURE__*/_jsx(Col, {
      lg: 6,
      xs: 12,
      children: /*#__PURE__*/_jsx("div", {
        className: "img-wrapper",
        children: /*#__PURE__*/_jsx(Image, {
          src: backgroundPath,
          alt: imageMeta || "ParallelogramImage",
          className: "img",
          priority: true,
          width: 1920,
          height: 1080
        })
      })
    })
  });
}
// EXTERNAL MODULE: ./src/components/shared/Button/Button.jsx
var Button = __webpack_require__(8122);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(4012);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Container.js
var esm_Container = __webpack_require__(682);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(4215);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Col.js
var esm_Col = __webpack_require__(1555);
;// CONCATENATED MODULE: ./src/components/AboutPage/AboutParallelogram/AboutParallelogram.jsx












function AboutParallelogram(_ref) {
  var primaryText = _ref.primaryText,
      secondaryText = _ref.secondaryText,
      backgroundPath = _ref.backgroundPath,
      withButton = _ref.withButton,
      onClickButtonFunction = _ref.onClickButtonFunction,
      imageMeta = _ref.imageMeta;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: (AboutParallelogram_module_default()).AboutParallelogram,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(esm_Container["default"], {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Row["default"], {
        className: "justify-content-between   align-items-center",
        children: [backgroundPath && /*#__PURE__*/(0,jsx_runtime.jsx)(esm_Col["default"], {
          lg: 5,
          xs: 12,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "img-wrapper",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
              src: backgroundPath,
              alt: imageMeta || "ParallelogramImage",
              className: "img",
              priority: true,
              width: 1920,
              height: 1080
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(esm_Col["default"], {
          lg: 6,
          xs: 12,
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (AboutParallelogram_module_default())["flex-col"],
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (AboutParallelogram_module_default()).flex,
              children: primaryText && /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                    id: "who-we-are"
                  })
                })
              })
            }), primaryText && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (AboutParallelogram_module_default()).flex,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
                children: primaryText
              })
            }), secondaryText && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (AboutParallelogram_module_default())["dangerous-text"],
              dangerouslySetInnerHTML: {
                __html: secondaryText
              }
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (AboutParallelogram_module_default())["action-row"],
              children: [withButton && (primaryText || secondaryText) ? /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
                buttonColor: "black",
                buttonShape: "square",
                buttonText: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                  id: "read-more"
                }),
                onClick: onClickButtonFunction
              }) : null, /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                href: "/contactus",
                passHref: true,
                children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
                  className: (AboutParallelogram_module_default())["cta-button-red"],
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                    id: "contact-us"
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: (AboutParallelogram_module_default())["icon-circle"],
                    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
                      width: "18",
                      height: "18",
                      viewBox: "0 0 18 18",
                      fill: "none",
                      xmlns: "http://www.w3.org/2000/svg",
                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
                        d: "M3.53577 3.53556L14.1424 14.1422",
                        stroke: "black",
                        strokeWidth: 1.5,
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
                        d: "M3.53553 10.6066L3.53553 3.53553L10.6066 3.53553",
                        stroke: "black",
                        strokeWidth: 1.5,
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                      })]
                    })
                  })]
                })
              })]
            })]
          })
        })]
      })
    })
  });
}

/***/ }),

/***/ 8122:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Button; }
/* harmony export */ });
/* harmony import */ var _home_mu7_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _Button_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1215);
/* harmony import */ var _Button_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Button_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);





function Button(_ref) {
  var _classNames;

  var buttonColor = _ref.buttonColor,
      buttonText = _ref.buttonText,
      buttonShape = _ref.buttonShape,
      onClick = _ref.onClick,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled;
  var wrapperClasses = classnames__WEBPACK_IMPORTED_MODULE_1___default()([(_Button_module_scss__WEBPACK_IMPORTED_MODULE_3___default().button)], (_classNames = {}, (0,_home_mu7_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_classNames, (_Button_module_scss__WEBPACK_IMPORTED_MODULE_3___default().red), buttonColor === "red"), (0,_home_mu7_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_classNames, (_Button_module_scss__WEBPACK_IMPORTED_MODULE_3___default().black), buttonColor === "black"), (0,_home_mu7_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_classNames, (_Button_module_scss__WEBPACK_IMPORTED_MODULE_3___default().rounded), buttonShape === "round"), (0,_home_mu7_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_classNames, (_Button_module_scss__WEBPACK_IMPORTED_MODULE_3___default().squared), buttonShape === "square"), (0,_home_mu7_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_classNames, (_Button_module_scss__WEBPACK_IMPORTED_MODULE_3___default().disabled), disabled), _classNames));
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("button", {
    onClick: onClick,
    className: wrapperClasses,
    disabled: disabled,
    children: buttonText
  });
}

/***/ }),

/***/ 3476:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/logo.72f176e4.png","height":3264,"width":5016,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAANlBMVEUBAAALAAD3AAALDhALGCAFCw4OGSABAAAOFx4AAADdAQIPFx6xBQjxAAAOGSIRFSIAFxcAGyS2XswHAAAAEnRSTlM7K1sySyGvJ4E4fVJZJp08C3gWJ2qoAAAACXBIWXMAAEzlAABM5QF1zvCVAAAALElEQVR4nAXBhwEAEBAAscNX3f7LSogRcUevbDNrb3ZEj4TUhTdX96IkCUn5HKQBEo69UrAAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":5});

/***/ }),

/***/ 6903:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"AboutParallelogram":"AboutParallelogram_AboutParallelogram__OtCXR","flex-col":"AboutParallelogram_flex-col__5FwBH","action-row":"AboutParallelogram_action-row__yOSay","cta-button-red":"AboutParallelogram_cta-button-red__B1BMN","icon-circle":"AboutParallelogram_icon-circle__oz2y4","flex":"AboutParallelogram_flex__nEof9","BlueHoleIcon":"AboutParallelogram_BlueHoleIcon__zKG1V"};

/***/ }),

/***/ 1215:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__4PSzu","red":"Button_red__wHc_V","black":"Button_black__4q2Dt","rounded":"Button_rounded__vANJA","squared":"Button_squared__Ct5BB","disabled":"Button_disabled__rRoIJ"};

/***/ }),

/***/ 1555:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "useCol": function() { return /* binding */ useCol; }
/* harmony export */ });
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _ThemeProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6792);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);
"use client";





function useCol({
  as,
  bsPrefix,
  className,
  ...props
}) {
  bsPrefix = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapPrefix */ .vE)(bsPrefix, 'col');
  const breakpoints = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapBreakpoints */ .pi)();
  const minBreakpoint = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapMinBreakpoint */ .zG)();
  const spans = [];
  const classes = [];
  breakpoints.forEach(brkPoint => {
    const propValue = props[brkPoint];
    delete props[brkPoint];
    let span;
    let offset;
    let order;
    if (typeof propValue === 'object' && propValue != null) {
      ({
        span,
        offset,
        order
      } = propValue);
    } else {
      span = propValue;
    }
    const infix = brkPoint !== minBreakpoint ? `-${brkPoint}` : '';
    if (span) spans.push(span === true ? `${bsPrefix}${infix}` : `${bsPrefix}${infix}-${span}`);
    if (order != null) classes.push(`order${infix}-${order}`);
    if (offset != null) classes.push(`offset${infix}-${offset}`);
  });
  return [{
    ...props,
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(className, ...spans, ...classes)
  }, {
    as,
    bsPrefix,
    spans
  }];
}
const Col = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(
// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
(props, ref) => {
  const [{
    className,
    ...colProps
  }, {
    as: Component = 'div',
    bsPrefix,
    spans
  }] = useCol(props);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Component, {
    ...colProps,
    ref: ref,
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(className, !spans.length && bsPrefix)
  });
});
Col.displayName = 'Col';
/* harmony default export */ __webpack_exports__["default"] = (Col);

/***/ }),

/***/ 4215:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _ThemeProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6792);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);
"use client";





const Row = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(({
  bsPrefix,
  className,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'div',
  ...props
}, ref) => {
  const decoratedBsPrefix = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapPrefix */ .vE)(bsPrefix, 'row');
  const breakpoints = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapBreakpoints */ .pi)();
  const minBreakpoint = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapMinBreakpoint */ .zG)();
  const sizePrefix = `${decoratedBsPrefix}-cols`;
  const classes = [];
  breakpoints.forEach(brkPoint => {
    const propValue = props[brkPoint];
    delete props[brkPoint];
    let cols;
    if (propValue != null && typeof propValue === 'object') {
      ({
        cols
      } = propValue);
    } else {
      cols = propValue;
    }
    const infix = brkPoint !== minBreakpoint ? `-${brkPoint}` : '';
    if (cols != null) classes.push(`${sizePrefix}${infix}-${cols}`);
  });
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Component, {
    ref: ref,
    ...props,
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(className, decoratedBsPrefix, ...classes)
  });
});
Row.displayName = 'Row';
/* harmony default export */ __webpack_exports__["default"] = (Row);

/***/ })

}]);